module.exports = __webpack_public_path__ + "static/surface-detail-636c52ac9a71b8a0a55dab707734a0e6.jpg";